import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { LockSettingsPage } from './LockSettingsPage'

export const routes: RouteObject[] = [{ path: '/settings/lock', element: <LockSettingsPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/lock', label: 'Блокировка', icon: 'lock', mobile: null, order: 91, parent: '/settings' },
]
